export function getAssetsBase() {
  // Prefer runtime-injected base from templates.
  // `src/partials/footer.html` sets window.ASSETS_BASE = "{{global.assetsBase}}"
  const b = (typeof window !== 'undefined' && window.ASSETS_BASE) ? String(window.ASSETS_BASE) : '';
  if (b) return b.endsWith('/') ? b : `${b}/`;
  // Fallback (kept to prevent hard failures if templates change)
  return '/content/dam/jpmc/static_sites/morgan-health/assets/';
}

